import { useEffect, useState } from 'react'
import { FF_MENU_SERVICE_MEMBERSHIP_PROMOTIONAL_TAG } from 'src/constants/experiments'
import { useExperiment } from './useExperiment'

export interface MembershipMainTagsText {
  addAndSaveCopy?: string
  premiumCopy?: string
}

export const useMembershipMainTagsText = (): {
  membershipDiscountCopy: MembershipMainTagsText | null
  isActive: boolean
} => {
  const [copyData, setCopyData] = useState<MembershipMainTagsText | null>(null)

  const { active, payload } = useExperiment(
    FF_MENU_SERVICE_MEMBERSHIP_PROMOTIONAL_TAG
  )

  useEffect(() => {
    // Handle Add and Save discount copy
    if (
      active &&
      payload?.value?.addAndSave?.postPriceText &&
      payload?.value?.premium?.postPriceText
    ) {
      setCopyData(prev => ({
        ...prev,
        premiumCopy: payload.value.premium.postPriceText,
        addAndSaveCopy: payload.value.addAndSave.postPriceText
      }))
    }
  }, [
    active,
    payload?.value?.addAndSave?.postPriceText,
    payload?.value?.premium?.postPriceText
  ])

  return {
    membershipDiscountCopy: copyData,
    isActive: !!active
  }
}
